import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  MenuItem,
  TextField,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AgentSelect from "../Salary/AgentSelect";
import { selectCurrentagency } from "../../../redux/features/authSlice";
import { useSelector } from "react-redux";
import { usePostAdvanceSalaryMutation } from "../../../redux/api/salary";

const AdvanceForm = () => {
  const currentAgency = useSelector(selectCurrentagency);

  const [formData, setFormData] = useState({
    AgentId: "",
    Amount: "",
    RequestDate: null,
    ApprovedDate: null,
    Status: "",
    DeductionMonth: null,
    Notes: "",
    AgencyId: currentAgency?.agencyid || null,
  });

  const [postAdvanceSalary, { isLoading }] = usePostAdvanceSalaryMutation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAgentChange = (e) => {
    const agentId = e.target.value;
    setFormData({ ...formData, AgentId: agentId });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        RequestDate: formData.RequestDate
          ? formData.RequestDate.toISOString()
          : null,
        ApprovedDate: formData.ApprovedDate
          ? formData.ApprovedDate.toISOString()
          : null,
        DeductionMonth: formData.DeductionMonth
          ? formData.DeductionMonth.toISOString()
          : null,
      };
      await postAdvanceSalary(payload).unwrap();
      setFormData({
        AgentId: "",
        Amount: "",
        RequestDate: null,
        ApprovedDate: null,
        Status: "",
        DeductionMonth: null,
        Notes: "",
        AgencyId: currentAgency?.agencyid || null,
      });
    } catch (error) {
      console.error("Error submitting advance salary:", error);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box p={3} border="1px solid #ccc" borderRadius={2}>
        <Typography variant="h6" gutterBottom>
          Advance Form
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Agent Select */}
            <Grid item xs={12} sm={6}>
              <AgentSelect
                agencyId={currentAgency?.agencyid}
                value={formData.AgentId}
                onChange={handleAgentChange}
              />
            </Grid>

            {/* Amount */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Amount"
                name="Amount"
                size= "small"
                value={formData.Amount}
                onChange={handleChange}
              />
            </Grid>

            {/* Status Dropdown */}
            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                size= "small"
                label="Status"
                name="Status"
                value={formData.Status}
                onChange={handleChange}
              >
                <MenuItem value={0}>Pending</MenuItem>
                <MenuItem value={1}>Approved</MenuItem>
                <MenuItem value={2}>Rejected</MenuItem>
              </TextField>
            </Grid>

            {/* Dates */}
            <Grid item xs={12} sm={6}>
              <DatePicker
                label="Request Date"
                sx={{ width: "100%" }}
                slotProps={{
                  textField: {
                    size: "small",
                  },
                }}
                value={formData.RequestDate}
                onChange={(newValue) =>
                  setFormData({ ...formData, RequestDate: newValue })
                }
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <DatePicker
                sx={{ width: "100%" }}
                slotProps={{
                  textField: {
                    size: "small", // 👈 makes it small like your Net Salary TextField
                  },
                }}
                label="Approved Date"
                value={formData.ApprovedDate}
                onChange={(newValue) =>
                  setFormData({ ...formData, ApprovedDate: newValue })
                }
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <DatePicker
                sx={{ width: "100%" }}
                label="Deduction Month"
                value={formData.DeductionMonth}
                onChange={(newValue) =>
                  setFormData({ ...formData, DeductionMonth: newValue })
                }
                slotProps={{
                  textField: {
                    size: "small", // 👈 makes it small like your Net Salary TextField
                  },
                }}
              />
            </Grid>
          </Grid>

          {/* Notes at full width, bottom of the form */}
          <Box mt={3}>
            <TextField
              fullWidth
              label="Notes"
              name="Notes"
              value={formData.Notes}
              onChange={handleChange}
              multiline
              rows={3}
            />
          </Box>

          <Box mt={3}>
            <Button
              type="submit"
              variant="contained"
              sx={{ color: "white" }}
              disabled={isLoading}
            >
              {isLoading ? "Submitting..." : "Submit Advance"}
            </Button>
          </Box>
        </form>
      </Box>
    </LocalizationProvider>
  );
};

export default AdvanceForm;
